import { getRequest, postRequest } from '@/utils/request';
var api = process.env['VUE_APP_COMPLIANCE_API'];
var tokenKey = 'token';
var defaultConfig = {
  baseUrl: api,
  tokenKey: tokenKey
};
/**
 * 顾问列表
 * @param data
 * @param config
 * @return {AxiosPromise}
 */
export var getAdviserList = function getAdviserList(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return getRequest('/adviser-info/get/adviser-list', data, Object.assign({}, defaultConfig, config));
};

/**
 * 获取用户绑定的顾问信息
 * @param data
 * @param config
 * @returns {AxiosPromise}
 */
export var getAdviserInfo = function getAdviserInfo(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return getRequest('/user-adviser-relation/user-adviser', data, Object.assign({}, defaultConfig, config));
};

/**
 * 绑定顾问
 * @param data = {adviserCode: xxxx}
 * @param config
 * @returns {AxiosPromise}
 */
export var bingingAdviser = function bingingAdviser(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return postRequest('/user-adviser-relation/binding', data, Object.assign({}, defaultConfig, config));
};